import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { lastValueFrom, map } from 'rxjs';
import {
  PageableRequest,
  PersonControllerService,
  PersonDetail
} from 'src/app/admin-api';
import { PageContent, TableColumn } from 'src/app/components/table';
import { BusinessUnit, getPersonTypesIncludeAll } from 'src/app/models';
import { FormUtil } from 'src/app/utils/form.util';

@Component({
  selector: 'app-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.scss'],
  providers: [DatePipe]
})
export class PersonComponent {
  cols = [
    new TableColumn.Builder()
      .setHeader('Id')
      .setField('personId')
      .setType('number')
      .setRouterLink('')
      .setBusinessUnit((p: PersonDetail) => p.businessUnitId)
      .setRouterLinkFieldName('personId')
      .build(),
    new TableColumn(
      'Nome',
      'name',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn(
      'Sobrenome',
      'lastName',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn(
      'Email',
      'username',
      true,
      'text',
      undefined,
      undefined,
      true,
      'startsWith'
    ),
    new TableColumn.Builder()
      .setHeader('CPF')
      .setField('cpf')
      .setFilter(true)
      .setType('inputMaskNumber')
      .setMask('999.999.999-99')
      .setDisplayFunction((person: PersonDetail) =>
        person.cpf ? FormUtil.cpfFormatted(person.cpf) : null
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Telefone')
      .setField('phone')
      .setType('inputMask')
      .setMask('(99) 99999-9999')
      .setFilter(true)
      .build(),
    new TableColumn(
      'Criação',
      'dateCreated',
      true,
      'date',
      undefined,
      undefined,
      true,
      'between'
    ),
    new TableColumn(
      'Últ. Atualização',
      'dateUpdated',
      false,
      'date',
      undefined,
      undefined,
      true,
      'between'
    ),
    new TableColumn(
      'Cupom',
      'couponName',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn(
      'Tipo',
      'personType',
      true,
      'text',
      undefined,
      undefined,
      true,
      'equals'
    ),
    new TableColumn.Builder()
      .setHeader('Clube')
      .setField('businessUnitId')
      .setType('number')
      .setDisplayFunction((p: PersonDetail) => BusinessUnit[p.businessUnitId])
      .build()
  ];
  dropdownFilters:
    | { [key: string]: Array<{ label: string; value: string }> }
    | undefined;

  constructor(
    public personService: PersonControllerService,
    private title: Title
  ) {
    this.title.setTitle('Usuários');
    this.dropdownFilters = {
      personType: getPersonTypesIncludeAll().map((pt) => ({
        label: pt.label,
        value: pt.value.toString()
      })),
      businessUnitId: [
        { label: 'Glam', value: BusinessUnit.Glam.toString() },
        { label: 'Mens', value: BusinessUnit.Mens.toString() }
      ]
    };
  }

  async findPage(
    request?: PageableRequest,
    service?: unknown
  ): Promise<PageContent<PersonDetail>> {
    const filterPersonType = request.filters?.find(
      (f) => f.field === 'personType'
    );
    if (filterPersonType?.value) {
      if (Number(filterPersonType.value) < 0) {
        filterPersonType.value = '';
      }
      request.filters?.push({
        condition: 'equals',
        field: 'personTypeId',
        fieldType: 'number',
        value: filterPersonType.value
      });
    }
    return lastValueFrom(
      (service as PersonControllerService)
        .listPersonTable(request)
        .pipe(map((data) => data.result as PageContent<PersonDetail>))
    );
  }
}
